import { render, staticRenderFns } from "./CoreSpecAttrDetail.vue?vue&type=template&id=33fea3b7&scoped=true"
import script from "./CoreSpecAttrDetail.vue?vue&type=script&lang=js"
export * from "./CoreSpecAttrDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fea3b7",
  null
  
)

export default component.exports